module.exports = __webpack_public_path__ + "img/card_250010783.bef776b1.jpg";